import { observer } from "mobx-react-lite";

import { useGeneralState } from "@/shared/stores/app-state";

export const StyleColorScheme = observer(() => {
	const { theme } = useGeneralState();

	return <style>{`html { color-scheme: ${theme}; }`}</style>;
});
